export const SecurityQuestionsType = Object.freeze({
	MothersMaidenName: "What is your mother's maiden name?",
	PetsName: "What is your pet's name?",
	BirthCity: 'What is your city of birth?',
	HighSchoolMascot: 'What was your high school mascot?',
	FathersBirthplace: "What is your father's birthplace?",
	StreetName: 'What street did you grow up on?',
	FirstSchoolsName: 'What is the name of your first school?',
	FirstCarsMakeModel: 'What is the make and model of your first car?',
	Last4SocialSecurityNumber:
		'What are the last 4 digits of your social security number?',
	Last4DriversLicense:
		'What are the last 4 digits of your drivers license number?',
});
